import React, { useEffect, useContext } from 'react';
import { StateContext, actions } from "../../../state/index";
import { validatePayment } from "../../../api/index";
import { ERROR_TYPES, TOKEN_TYPES } from "../../../utils/enums";
import ValidatingPayment from '../views/ValidatingPayment';

// initially, the only data used for validation flows is pulled from the URL that the user uses to access the paywall
// eventually, there may be flows where the user needs to provide additional information to verify their identity
export const ValidateUsingPaywallURLFlow = ({url = window.location.href}) => {
  // eslint-disable-next-line no-empty-pattern
  let [{}, dispatch] = useContext(StateContext);
  useEffect(() => {
    const fetchValidationToken = async () => {
      try {
        const URL = new window.URL(url);
        const paymentId = URL.pathname.substring(1);
        const queryParams = new URLSearchParams(window.location.search);
        const refId = queryParams.get('refid');
        const lastName = queryParams.get('lastname');
        debugger
        const response = await validatePayment(paymentId, {refId, lastName});
        dispatch(actions.tokens.setToken(TOKEN_TYPES.VALIDATE_PAYMENT, response.data.access_token))
      }
      catch (error) {
        debugger
        console.error(url, error);
        dispatch(actions.modals.showErrorModal({
          error,
          errorType: ERROR_TYPES.validatePaymentError,
          actions: ['Try Again', fetchValidationToken]
        }))
      }
    };
    fetchValidationToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ValidatingPayment/>
  );
};

export default ValidateUsingPaywallURLFlow;

